<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:masterDetail="masterDetail"
			:modelColumnDefs="modelColumnDefs"
			:externalFilter="externalFilter"
			:readOnly="readOnly"
			:parentModelName="parentModelName"
			:parentModel="parentModel"
			:showMasterDetailFilterListBtn="true"
			:showMasterDetailFilterBtn="true"
			:showMasterDetailSortBtn="true"
			:showMasterDetailConfBtn="true"
			:showCreateBtn="showCreateBtn"
			:showDeleteBtn="showDeleteBtn"
		></pui-datatable>
		<portcallinvoices-modals :modelName="modelName"></portcallinvoices-modals>
	</div>
</template>

<script>
import portcallinvoicesActions from './PortcallinvoicesActions';
import portcallinvoicesModals from './PortcallinvoicesModals.vue';
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';

export default {
	name: 'portcallinvoices-grid',
	mixins: [PuiGridDetailMixin],
	components: {
		'portcallinvoices-modals': portcallinvoicesModals
	},
	data() {
		return {
			modelName: 'portcallinvoices',
			actions: portcallinvoicesActions.gridactions,
			modelColumnDefs: {}
		};
	},
	computed: {
		isShipAgentProfile() {
			const profiles = this.$store?.getters?.getSession?.profiles || [];
			return profiles.includes('SHAG');
		},
		showCreateBtn() {
			return !this.isShipAgentProfile;
		},
		showDeleteBtn() {
			return !this.isShipAgentProfile;
		}
	}
};
</script>
